<div class="cipx-form-section" [formGroup]="requestDetailsGroup">
  <fieldset>
    <legend class="cipx-form-section-title">
      Bond Information
    </legend>



    <!-- Disclaimer -->
    <blockquote class="cipx-form-disclaimer-box">
      This information may print on your bond and should match the information
      used on other licensing documentation.
    </blockquote>

    <!-- Number of Owners -->
    @if (quoteRequestForm.controls.bondLookup.controls.company_type_id.value !== 3) {
    <div class="cipx-form-form-group">
      <label class="cipx-form-label">How many owners?</label>
      <mat-button-toggle-group
        (change)="onCompanyNumberOwnersChange($event)"
        formControlName="company_number_owners"
        name="company_number_owners"
        aria-label="Number of Owners">
        <mat-button-toggle [value]="1">1</mat-button-toggle>
        <mat-button-toggle [value]="2">2</mat-button-toggle>
        <mat-button-toggle [value]="3">3</mat-button-toggle>
        <mat-button-toggle [value]="4">4</mat-button-toggle>
        <mat-button-toggle [value]="5">5</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    }

    <div class="cipx-form-form-group" formGroupName="principal">
      <mat-form-field [subscriptSizing]="'dynamic'" [hideRequiredMarker]="true">
        <mat-label>
          {{
            quoteRequestForm.controls.bondLookup.controls.company_type_id.value === 3
              ? 'Name as it should appear on bond?'
              : 'Company Name'
          }}
        </mat-label>
        <input
          matInput
          formControlName="company_name"
          placeholder="Company Name" />
        <mat-error *ngIf="requestDetailsGroup.get('principal.company_name')?.hasError('required')">
          Company name is required
        </mat-error>
        <mat-error *ngIf="requestDetailsGroup.get('principal.company_name')?.hasError('minlength')">
          Company name must be at least 2 characters
        </mat-error>
        <mat-error *ngIf="requestDetailsGroup.get('principal.company_name')?.hasError('pattern')">
          Company name must contain at least 2 non-whitespace characters
        </mat-error>
      </mat-form-field>
      @if (quoteRequestForm.controls.bondLookup.controls.company_type_id.value === 5 && !((requestDetailsGroup.get('principal.company_name')?.value || '').toLowerCase().includes('llc'))) {
        <div class="alert alert-warning flex items-center gap-2">
          <mat-icon class="mt-[2px]">warning</mat-icon>
          <span>Should your company name include "LLC"? The name should match your legal business name.</span>
        </div>
        }
        @if (quoteRequestForm.controls.bondLookup.controls.company_type_id.value === 6 && !((requestDetailsGroup.get('principal.company_name')?.value || '').toLowerCase().includes('llp'))) {
        <div class="alert alert-warning flex items-center gap-2">
          <mat-icon class="mt-[2px]">warning</mat-icon>
          <span>Should your company name include "LLP"? The name should match your legal business name.</span>
        </div>
        }
      <mat-form-field [subscriptSizing]="'dynamic'" [hideRequiredMarker]="true">
        <mat-label>Other Business or Trade Names (leave blank if none)</mat-label>
        <input
          matInput
          formControlName="company_dba"
          placeholder="Business or Trade Name" />
        <mat-hint><strong>Doing Business As (DBA):</strong>  you are conducting business under another name please enter the name(s) here. This information may be added to the name on the bond. For example, if the company name is "Acme, Inc." but you operate as "Explosives & Anvil Depot" you would enter "Explosives & Anvil Depot" here and your bond would be for "Acme, Inc. DBA Explosives & Anvil Depot" if this information is required for your specific bond form.</mat-hint>
      </mat-form-field>
    </div>

    <div class="cipx-form-form-group">
      <mat-form-field [subscriptSizing]="'dynamic'" [hideRequiredMarker]="true">
        <mat-label>How many years in business?</mat-label>
        <input
          matInput
          type="number"
          formControlName="company_years_in_business"
          placeholder="Years in business" />
        <mat-error *ngIf="requestDetailsGroup.get('company_years_in_business')?.hasError('required')">
          Years in business is required
        </mat-error>
        <mat-error *ngIf="requestDetailsGroup.get('company_years_in_business')?.hasError('min')">
          Years in business must be 0 or greater
        </mat-error>
      </mat-form-field>
    </div>

    @if(quoteRequestForm.controls.bondLookup.controls.company_type_id.value === 3) {
    <div class="cipx-form-form-group">
      <mat-checkbox formControlName="addCompanyAddress">
        Add a business address
      </mat-checkbox>
    </div>
    } @if(quoteRequestForm.controls.requestDetails.controls.addCompanyAddress.value === true) {
    <div class="cipx-form-form-group">
      <sbd-app-address-form
        prefix="company_"
        [showCounty]="false"
        [formGroup]="principal"></sbd-app-address-form>
    </div>
    }
  </fieldset>

    @if (selectedStateBond() !== null &&
    sectionHasQuestions('principal', selectedStateBond())) {
      <fieldset>
        <cipx-quote-request-intake-form-question-set
          [quoteRequestForm]="quoteRequestForm"
          [stateBond]="selectedStateBond()"
          sectionName="principal"></cipx-quote-request-intake-form-question-set>
      </fieldset>
    }

</div>

<!-- Effective Date - separate section because it's at root level -->
<div class="cipx-form-section" [formGroup]="quoteRequestForm">
  <div class="cipx-form-form-group">
    <mat-form-field [subscriptSizing]="'dynamic'" [hideRequiredMarker]="true">
      <mat-label>
        Effective date?
        <a
          class="text-primary cursor-pointer"
          (click)="setEffectiveDateToday()">
          Today
        </a>
      </mat-label>
      <input matInput [matDatepicker]="picker" formControlName="requested_coverage_begin_date">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="quoteRequestForm.get('requested_coverage_begin_date')?.hasError('required')">
        Effective date is required
      </mat-error>
    </mat-form-field>
  </div>
</div>
